import { render } from "./MenuButton.vue?vue&type=template&id=7f086f44&scoped=true&ts=true&lang=pug"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"

import "./MenuButton.vue?vue&type=style&index=0&id=7f086f44&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f086f44"]])

export default __exports__